import { render, staticRenderFns } from "./ColumnVisibilitySidebar.vue?vue&type=template&id=2b84761e"
import script from "./ColumnVisibilitySidebar.vue?vue&type=script&lang=js"
export * from "./ColumnVisibilitySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports